function JustOneRedirectLink() {
  $('a[data-one-redirect-link]').one('click', event => {
    event.target.addEventListener('click', event => {
      event.preventDefault();
    });
  });
}

exports.init = JustOneRedirectLink;
